import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: 'f4c975cb-a15b-43da-b06f-d651b298ae4b',
	[AppLanguageCodes.SK]: 'f4c975cb-a15b-43da-b06f-d651b298ae4b',
	[AppLanguageCodes.DE]: 'f4c975cb-a15b-43da-b06f-d651b298ae4b',
}


export const AdvantagesProbe = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds}>
		</MdxDiv>
	);
};